import { Clock8Icon } from 'lucide-react'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

type PropsType = {
  id?: string
  value?: string
  defaultValue?: string
  showSeconds?: boolean
  className?: string
  onChange?: (value: string) => void
}

const TimeInput = ({ id, value, defaultValue, showSeconds = true, className, onChange }: PropsType) => {
  const emptyValue = showSeconds ? '00:00:00' : '00:00'

  return (
    <div className={cn('inline-flex w-fit', className)}>
      <Input
        type="time"
        id={id || 'time-input'}
        icon={<Clock8Icon className="size-4" />}
        {...(showSeconds ? { step: '1' } : {})}
        {...(value !== undefined
          ? { value, onChange: e => onChange?.(e.target.value) }
          : { defaultValue: defaultValue || emptyValue })}
        className="bg-background appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
      />
    </div>
  )
}

export default TimeInput
